import gtm from '@/utils/gtm';
import ShopifyCartIcon from '@elem/compCommon/ShopifyCartIcon';
import ShopifyShoppingCart from 'elem/compCommon/ShopifyShoppingCart';
import { ShopifyCartItemType } from 'elem/compCommon/ShopifyShoppingCart/const';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import ProductNav from '../../../common/ProductNav';
import { tabsValues } from '../../../config/pageConfig';
import Specs from '../../specs';
import Support from '../../support';
import Bundles from '../Bundles';
import ApplianceRatings from '../components/ApplianceRatings';
import BannerA from '../components/BannerA';
import FooterTcA from '../components/FooterTcA';
import IndustryLeadingA from '../components/IndustryLeadingA';
import IndustryLeadingB from '../components/IndustryLeadingB';
import IndustryLeadingC from '../components/IndustryLeadingC';
import IndustryLeadingD from '../components/IndustryLeadingD';
import IndustryLeadingE from '../components/IndustryLeadingE';
import IndustryLeadingF from '../components/IndustryLeadingF';
import PowerTechnology from '../components/PowerTechnology';
import ProductCheckList from '../components/ProductCheckList';
import ProductComparison from '../components/ProductComparison';
import SectionPicture from '../components/SectionPicture';
import UsageScenariosA from '../components/UsageScenariosA';
import UsageScenariosB from '../components/UsageScenariosB';
import UsageScenariosC from '../components/UsageScenariosC';
import UsageScenariosD from '../components/UsageScenariosD';
import UsedDuringDisasters from '../components/UsedDuringDisasters';
import SingleItemCard from '../components/SingleItemCard';
import FixProcess from '../components/FixProcess';
import PageNavLeft from '../components/PageNavLeft';
import { useLang } from '@/i18n';

export default function StatusItem() {
    const [isClient, setIsClient] = useState(false);
    const [shoppingCarts, setShoppingCarts] = useState([]);
    const [visible, setVisible] = useState(false);
    const { query } = useRouter();
    const searchTab = query?.tab;
    const IndustryLeadingEREF = useRef();
    const { t } = useLang('Delta3MaxSeriesStation');
    let defaultTab = 'Product';
    if (typeof searchTab === 'string' && tabsValues.includes(searchTab)) {
        defaultTab = searchTab;
    }
    const [activeTab, setActiveTab] = useState(defaultTab);
    const tabCallback = (tabValue: string) => {
        setActiveTab(tabValue);
    };
    const handleAddToCart = (card: any, list_name?: string) => {
        if (card?.inventory <= 0) {
            return;
        }

        const obj: ShopifyCartItemType = { ...card };
        const target = shoppingCarts.find((item: ShopifyCartItemType) => item?.productId === card?.productId && item?.variantId === card?.variantId);
        if (target) {
            obj.quantity = target.quantity + (target?.quantity < target.inventory ? 1 : 0);
            setShoppingCarts([
                obj,
                ...shoppingCarts?.filter((item: ShopifyCartItemType) => !(item?.productId === card?.productId && item?.variantId === card?.variantId)),
            ]);
        } else {
            obj.quantity = Number(obj?.inventory) > 0 ? 1 : 0;
            setShoppingCarts([obj, ...shoppingCarts]);
        }
        setVisible(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'bundle_add_to_cart',
            product_name: card?.name || card?.title,
            list_name: list_name || 'none',
            price: card?.discountPrice,
            tag: 'none',
            quantity: obj?.quantity,
            button_name: card?.buyText || '',
            __btn_type: 'common',
            __btn_id1: card.className2,
            __btn_id2: card.className2,
        });
    };

    const handleCallback = (carts: ShopifyCartItemType[], isClose?: boolean) => {
        setShoppingCarts(carts);
        if (isClose) {
            setVisible(false);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);
    const linkClick = (index) => {
        IndustryLeadingEREF.current?.changeTwoItem(index);
    };
    return (
        <>
            <ProductNav activeTab={activeTab} tabCallback={tabCallback} />
            {activeTab === 'Product' && (
                <div className="Product">
                    <BannerA />
                    <SectionPicture linkClick={linkClick} />
                    <SingleItemCard addShopCartCallback={handleAddToCart} />
                    {/* <FixProcess /> */}
                    <UsageScenariosA />
                    <IndustryLeadingA />
                    <UsageScenariosB />
                    <IndustryLeadingB />
                    <UsageScenariosC />
                    <IndustryLeadingC />
                    <IndustryLeadingD />
                    <UsageScenariosD />
                    <IndustryLeadingE ref={IndustryLeadingEREF} />
                    <IndustryLeadingF />
                    <PowerTechnology />
                    <ProductComparison />
                    <ApplianceRatings />
                    <UsedDuringDisasters />
                    <ProductCheckList />
                    <FooterTcA />
                    <PageNavLeft
                        triggerElement=".delta-3-max-series .Product"
                        enterElement="#SingleItemCard"
                        steps={[
                            { text: t('FixProcess.KSP-1'), href: '#UsageScenariosA' },
                            { text: t('FixProcess.KSP-2'), href: '#UsageScenariosB' },
                            { text: t('FixProcess.KSP-3'), href: '#UsageScenariosC' },
                            { text: t('FixProcess.KSP-4'), href: '#IndustryLeadingD' },
                            { text: t('FixProcess.KSP-5'), href: '#UsageScenariosD' },
                            { text: t('FixProcess.KSP-6'), href: '#IndustryLeadingF' },
                            { text: t('FixProcess.KSP-7'), href: '#PowerTechnology' },
                        ]}
                    />
                </div>
            )}
            {activeTab === 'Specs' && (
                <>
                    <Specs />
                </>
            )}
            {activeTab === 'Support' && (
                <>
                    <Support />
                </>
            )}
            {activeTab === 'Bundles' && (
                <>
                    <Bundles addShopCartCallback={handleAddToCart} />
                    <FooterTcA />
                </>
            )}
            {visible && isClient && createPortal(<ShopifyShoppingCart callback={handleCallback} items={shoppingCarts} />, document.body)}
            {isClient &&
                createPortal(
                    <ShopifyCartIcon
                        quantity={shoppingCarts.reduce((prev: number, curItem: ShopifyCartItemType) => {
                            return prev + Number(curItem.quantity);
                        }, 0)}
                        callback={() => setVisible(true)}
                    />,
                    document.body,
                )}
        </>
    );
}
